// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1sUk3","consentsList":"PatientConsents_consentsList__jVUnG","consentsListEmpty":"PatientConsents_consentsListEmpty__3hs9n"};